
import { TbCamera, TbMail, TbPencil, TbPhone,  TbPhotoEdit  } from 'react-icons/tb';
import {  Button, Col, Dialog, FabButton, Flex, Icon, InputField, Row, Snackbar, Typography } from '../../ppui';
import { ORGANIZATION_FORM_FIELDS } from './profile/profile-contants';
import useOrganisationService from './profile/use-profile-service';
import {  OrganasationLogo, OrganasationName, OrganizationHeader, OrganizationWrapper, PhotoIcon, PhotoUpload,  } from '../style';

import { useAuthContext } from '../../context/authContext';
import { LuGlobe } from 'react-icons/lu';
import Logo from '../../assets/svgs/logo';
import OrganasationCover from '../../assets/svgs/organasation-svg';



const OrganizationStickyHeader = () => {
  const {
    orgDetails: fromGblobalorgDetails,
  } = useAuthContext();





  const {
    handleClick,
    fileInputRef,
    setPreviewURL,
    setSelectedFile,
    previewURL,
    setOrgProfile,
    getInputFieldProps,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    openSnackbar,
    basicInfoModalOpen,
    handleClosebasicInfoModal,
    handleOpenbasicInfoModal,
  } = useOrganisationService();

  return (
    <>
      <OrganizationWrapper>
        <OrganizationHeader>
          <OrganasationLogo>
              {fromGblobalorgDetails?.logo ? 
            
              <img src={`${fromGblobalorgDetails?.path + fromGblobalorgDetails?.logo}`} />
                :
                <Logo/>
            }

          </OrganasationLogo>
          <OrganasationName>
            <OrganasationCover/>
            <Typography variant='h3' color="light" textCase="capitalize" mb="0" colorVariant="light">
              {fromGblobalorgDetails?.org_name || 'N/A'}
            </Typography>
            <Row alignItem="flex-end" >
              <Col>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbPhone />
                  </Icon>
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    {fromGblobalorgDetails?.phone || 'N/A'}
                  </Typography>
                  {fromGblobalorgDetails?.landline && 
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    / {fromGblobalorgDetails?.landline}
                  </Typography>
                  }
                </Flex>
                <Flex alignItem="center" gap={5}>
                  <Icon color={"light"}>
                    <TbMail />
                  </Icon>
                  <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                    {fromGblobalorgDetails?.email || 'N/A'}
                  </Typography>
                </Flex>
                {fromGblobalorgDetails?.domain_name &&
                  <Flex alignItem="center" gap={5}>
                    <Icon color={"light"}>
                      <LuGlobe/>
                    </Icon>
                    <Typography variant="body2" mb={"0"}  color="light" colorVariant="dark">
                      {fromGblobalorgDetails?.domain_name || 'N/A'}
                    </Typography>
                  </Flex>
                }
              </Col>
              <Col sm={"auto"}>
                <Button variant='filled' color='light' size='sm'
                  icon={<TbPencil/>}
                  onClick={handleOpenbasicInfoModal}
                >Edit 
                </Button>
              </Col>
            </Row>
          </OrganasationName>
        </OrganizationHeader>
      </OrganizationWrapper>
      
      <Dialog
        title="Basic Information"
        closeButton={true}
        fullWidth
        maxWidth="xs"
        open={basicInfoModalOpen}
        buttonName={"Update"}
        onClose={handleClosebasicInfoModal}
        onSubmit={handleClick}
        separator
        bodyScroll={true}
      >
        <Row rowGap>
          <Col sm={12} md={"auto"}>
            <PhotoUpload
              onClick={() => {
                if (fileInputRef.current) {
                  fileInputRef.current.click();
                }
              }}
            >
              {!previewURL &&
                <TbPhotoEdit />
              }
              <input
                type="file"
                id="image"
                name="image"
                onChange={(event) => {
                  const file = event.target.files[0]; // Get the selected file
                  if (file) {
                    // Check if the file size is within the 2 MB limit
                    const maxSizeInBytes = 2 * 1024 * 1024; // 2 MB in bytes
                    if (file.size > maxSizeInBytes) {
                      openSnackbar({
                        message: "File size should not exceed 2 MB.",
                        color: "danger",
                      });


                      return; // Stop if file is too large
                    }
                    const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];

                    if (!allowedTypes.includes(file.type)) {
                      openSnackbar({
                        message: "Only JPG & PNG files are allowed.",
                        color: "danger",
                      });
                      return; // Stop if the file type is not allowed
                    }

                    setSelectedFile(file);
                    setPreviewURL(URL.createObjectURL(file)); // Create a preview URL

                    setOrgProfile((prevUser) => ({
                      ...prevUser,
                      logo: file,
                    }));
                  }
                }}
                ref={fileInputRef}
                accept=".png, .jpg, image/jpeg"
                hidden
              />
            
              {previewURL && <img src={previewURL} alt="" />}
              {/* {
                fromGblobalorgDetails?.logo && fromGblobalorgDetails?.path &&  <img src={`${fromGblobalorgDetails?.path+fromGblobalorgDetails?.logo}`}/>
              } */}

              <PhotoIcon>
                <FabButton size="xs" variant="contained" color="primary" icon={previewURL ? <TbPencil /> : <TbCamera />} />
              </PhotoIcon>
            </PhotoUpload>
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.org_name.name)}
            />
          </Col>
          
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.phone.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.landline.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.email.name)}
            />
          </Col>
          <Col xs={12}>
            <InputField
              {...getInputFieldProps(ORGANIZATION_FORM_FIELDS.domain_name.name)}
            />
          </Col>
        </Row>
      </Dialog>
      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={
          closeSnackbar}
        onOpen={snackbarVisible}
        loading={false}
        duration={3000}
      />
    </>
  )
}

export default OrganizationStickyHeader